import { SALES_PLANNER_USER_SETTINGS_DEFAULTS } from '@quorum/models/xs-resource';
import { LocalSettingsState } from './local-settings.interfaces';

// Persisted-subset defaults are owned by the shared `SALES_PLANNER_USER_SETTINGS_DEFAULTS` schema
// (see libs/models/xs-resource/crm/sales-planner-user-settings.model.ts) so the server's DynamoDB
// defaults and these client-side defaults can never drift. The session-only fields below
// (activitiesFilter, startDate, prospectFilter, prospectSortBy, settingsChanged) are intentionally
// not persisted and therefore stay defined here.
export const initialLocalSettingsState: LocalSettingsState = {
  ...SALES_PLANNER_USER_SETTINGS_DEFAULTS,
  activitiesFilter: ['A', 'D', 'P', 'T', 'S'],
  startDate: new Date(),
  prospectFilter: { typeId: [3, 4, 6], channel: [], source: [], status: [1, 2], sort: '-enteredDate' },
  prospectSortBy: '-enteredDate',
  settingsChanged: [],
};
